import {type FC, useEffect, useRef} from 'react';
import {PleaseWaitText, SplashImg, StreamingWrapper} from './types/Streaming.styled.ts';
import TimelineBar from './component/TimelineBar.tsx';
import useCenterStore from '../../store/useCenterStore.ts';
import useStreamingStore from '../../store/useStreamingStore.ts';
import Streaming from './component/Streaming.tsx';
import {setFocus} from '@noriginmedia/norigin-spatial-navigation';
import VodPlayer from './component/VodPlayer.tsx';
import NoStreaming from './component/NoStreaming.tsx';
import {isBroadcastOver} from '../../utils/StreamingUtil.ts';
import {getTodayEvents} from '../../utils/DateUtil.ts';
import callApi from '../../apis/callApi.ts';

const StreamingPage: FC = () => {
    const {centerInfo, allDevices, setAllDevices} = useCenterStore();
    const {
        state,
        setIsSplash,
        scheduledData,
        setScheduledData,
        streamingPollingData,
        setJitsiToken,
        setStreamingState,
        isSplashOn,
    } = useStreamingStore();
    const tvScheduleInterval = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        setFocus('streaming');
        setIsSplash(true);
        setTimeout(() => {
            setIsSplash(false);
        }, 3000);
    }, []);

    const fetchData = async () => {
        const {data} = await callApi().get('/tvs/schedule/client/');
        setScheduledData(getTodayEvents(data.slides));
        if (centerInfo && centerInfo.center_id) {
            const token = await setJitsiToken(centerInfo?.center_id);
            setStreamingState({jwt: token});
        }
        if (allDevices.length < 3) {
            await setAllDevices();
        }
    };

    useEffect(() => {
        if (centerInfo?.id) {
            fetchData();
            tvScheduleInterval.current = setInterval(fetchData, 60000);
            return () => {
                if (tvScheduleInterval.current) clearInterval(tvScheduleInterval.current);
                tvScheduleInterval.current = null;
            };
        }
    }, [centerInfo]);

    return (
        <StreamingWrapper>
            {
                <SplashImg $show={isSplashOn}>
                    <PleaseWaitText>
                        <div>화면을 전환 중입니다...</div>
                    </PleaseWaitText>
                </SplashImg>
            }

            {/* 방송이 있을 경우 (스트리밍) */}
            {streamingPollingData && streamingPollingData.broadcast.content_type === 'live' && state.jwt &&
                <Streaming/>}

            {/* 방송이 있을 경우 (VOD) */}
            {streamingPollingData && streamingPollingData.broadcast.content_type === 'vod' && (
                // <Streaming/>
                <VodPlayer
                    videoUrl={streamingPollingData.broadcast.vod.video}
                    startTime={streamingPollingData.broadcast.start_time}
                    endTime={streamingPollingData.broadcast.end_time}
                />
            )}

            {/* 방송이 없을 경우 */}
            {streamingPollingData && streamingPollingData.broadcast.content_type === null && (
                // <Streaming/>
                <NoStreaming/>
            )}

            {/* 방송이 있을 경우 (타임 라인) */}
            {streamingPollingData && scheduledData && !isBroadcastOver(scheduledData) && (
                <TimelineBar events={scheduledData}/>
            )}
        </StreamingWrapper>
    );
};

export default StreamingPage;
